import { createContext, useContext } from 'react';
import type { FeedItem } from '@/lib/feed';

export interface FleetFeed {
  items: FeedItem[];
  /**
   * Whose journal this is, because the two feeds are different feeds and the rail
   * has to say so: `fleet` is the whole organisation's, `mine` is the devices and
   * briefs of the person reading it. Both are live streams; the difference is
   * scope, not freshness.
   */
  scope: 'fleet' | 'mine';
}

/** The activity feed, owned by the app shell so the SSE connection outlives routes. */
export const FleetFeedContext = createContext<FleetFeed>({ items: [], scope: 'mine' });

export function useFleetFeed(): FleetFeed {
  return useContext(FleetFeedContext);
}
